import {InjectionToken} from '@angular/core';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {Action, ActionReducer, ActionReducerMap, INIT, MetaReducer} from '@ngrx/store';
import {environment} from '../../environments/environment';
import {
  errorHandlingFeatureKey,
  reducer as errorReducer,
  ErrorState,
  initialErrorState,
} from '../error/error-handling/error-handling.reducer';
import {
  bundleListFeatureKey,
  reducer as bundleListReducer,
  BundleListState,
  initialBundleListState,
} from '../features/bundle-list/store/bundle-list.reducer';
import {
  initialProductState,
  productFeatureKey,
  reducer as productReducer,
  ProductState,
} from '../features/product-list/store/product-list.reducer';
import {
  historyFeatureKey,
  reducer as historyReducer,
  HistoryState,
  initialHistoryState,
} from '../state/router/router.reducer';

export interface AppState {
  router: RouterReducerState;
  [errorHandlingFeatureKey]: ErrorState;
  [productFeatureKey]: ProductState;
  [bundleListFeatureKey]: BundleListState;
  [historyFeatureKey]: HistoryState;
}

const appInitialState: AppState = {
  router: {} as RouterReducerState,
  [errorHandlingFeatureKey]: initialErrorState,
  [productFeatureKey]: initialProductState,
  [bundleListFeatureKey]: initialBundleListState,
  [historyFeatureKey]: initialHistoryState,
};

export const ROOT_REDUCERS: InjectionToken<ActionReducerMap<AppState, Action>> = new InjectionToken<
  ActionReducerMap<AppState, Action>
>('Root reducers token', {
  factory: () => ({
    router: routerReducer,
    [errorHandlingFeatureKey]: errorReducer,
    [productFeatureKey]: productReducer,
    [bundleListFeatureKey]: bundleListReducer,
    [historyFeatureKey]: historyReducer,
  }),
});

export function resetState(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    if (action !== null && action.type === '[Reset]') {
      return reducer(appInitialState, {type: INIT});
    }
    return reducer(state, action);
  };
}

const productionMetaReducers: MetaReducer<AppState>[] = [];
const developmentMetaReducers: MetaReducer<AppState>[] = [resetState];

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? developmentMetaReducers
  : productionMetaReducers;
